module.exports = __webpack_public_path__ + "img/general-yabbr.afccf898.png";